var _path, _line, _circle, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGymnastics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.8,257.6c-21,22.9-43.5,30.4-72.7,19.9l-279.2-89.6c-10.2-3.7-21.6,1.1-26.2,10.9v0 c-4.9,10.4-0.5,22.8,9.8,27.9l258.9,115.9c0,0,54.9,100.8,209.1,192.2l54.7,379.5c1.7,13,12.7,22.8,25.9,22.8l0,0 c13.9,0,25.4-11,26-24.9l20-385.2l131.3-65.8c32.8-15.4,51.5-50.7,45.8-86.5l-10.9-178.1c-2.1-13-14.4-21.6-27.3-19.2l0,0 c-11.2,2.1-19.3,12.1-19,23.5l-16.6,160.5c0,0,13.8,7.9-58,8.5c-21.5,0.2-64.5-2.2-104.1,22.2c-15.9,9.8-54.8-117.5-54.8-117.5 L840,172.8c8.7-4.3,12.2-14.9,7.8-23.6v0c-3.8-7.4-12.2-11-20.2-8.8c-52.4,14.7-238.3,56.4-260.6,61.9c-26,6.5-38.1,21.9-65.7,53.6 C500.8,256.5,500.3,257,499.8,257.6z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 726.1,
    y1: 526.9,
    x2: 662.9,
    y2: 564.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 428.6,
    cy: 152.4,
    r: 65.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 871.2,
    y1: 937,
    x2: 211.6,
    y2: 937
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymnastics);
export default __webpack_public_path__ + "static/media/Gymnastics.88858b03691196a8425603da2a540d1d.svg";
export { ForwardRef as ReactComponent };